<template>
    <f7-page
        name="Goals"
        class="onboardingBg"
    >
        <f7-navbar
            large
            title-large="Your Goals"
            large-transparent
            inner-class="onboardingBg"
        >
            <f7-nav-left>
                <f7-link
                    back
                    icon="ion-ios-arrow-left"
                />
            </f7-nav-left>
            <f7-nav-title>Your Goals</f7-nav-title>
        </f7-navbar>

        <f7-block>Your goals let us know what content will serve you best. We use this information to create your personal journey and never share this information with anyone else.</f7-block>
        <f7-list>
            <template v-for="(topic, index) in topics">
                <f7-list-item
                    v-show="isEligible(topic) || myTopics.indexOf(topic.id) > -1"
                    :key="`topic-${index}-${myTopics}`"
                    :title="topic.name"
                    :checked="myTopics.indexOf(topic.id) > -1"
                    checkbox
                    name="goal"
                    @change="onTopicChange(topic.id)"
                />
            </template>
        </f7-list>

    </f7-page>
</template>

<script>
import utils from '../../js/utils';

export default {
    store: ['api', 'user', 'myTopics', 'topics', 'topicsIndex', 'myTopics', 'myTraits'],
    data () {
        return {
        };
    },
    computed: {},
    created: function () {
        this.getMyTopics();
    },
    mounted: function () { },
    methods: {
        onTopicChange: function (topicId) {
            const topic = this.topicsIndex[topicId];
            if (this.myTopics.indexOf(topicId) > -1) {
                if (this.myTopics.length > 0) this.myTopics.splice(this.myTopics.indexOf(topicId), 1);
                this.$events.fire('trackEvent', `topic_removed`, 'content', topic.id, topic.name, topic);
            } else {
                this.myTopics.push(topicId);
                this.$events.fire('trackEvent', `topic_added`, 'content', topic.id, topic.name, topic);
            }
            this.saveMyTopics();
        },
        getMyTopics: function () {
            f7.preloader.show();
            this.$http.get(`${this.api}/users/${this.user.id}/topics`).then(
                response => {
                    let topics = response.body;
                    for (let i = 0; i < topics.length; i++) {
                        topics[i] = parseFloat(topics[i]);
                    }
                    this.myTopics = topics;
                    f7.preloader.hide();
                },
                response => {
                    f7.preloader.hide();
                    f7.dialog.alert(response.body.message || 'Unknown error');
                }
            );
        },
        saveMyTopics: function () {
            this.$http.post(`${this.api}/users/${this.user.id}/topics`, {
                topicIds: this.myTopics
            }).then(
                () => {
                    console.log('topics saved');
                },
                response => {
                    console.error(response.body.message || 'Unknown error');
                }
            );
        },
        isEligible: function (topic) {
            return topic.type === 'goal' && utils.checkTraits(this.myTraits, topic);
        },
    }
};
</script>
<style lang="less" scoped>
@import '../../css/colors.less';
.block-title {
    text-align: center;
    text-transform: uppercase;
    font-size: 12px;
    color: black;
    font-weight: bold;
}
.list.inset {
    border: 3px solid @black;
    border-radius: 0px;
}
.center {
    text-align: center;
}
</style>
